import styled from "styled-components";

export const H1 = styled.h1(() => {
    return `
        font-family: Poppins;
        font-weight: 800;
        font-size: 45px;
        line-height: normal;
        overflow: hidden;
        text-overflow: ellipsis;
    `
});

export const H2 = styled.h2(() => {
    return `
        font-family: Poppins;
        font-weight: 700;
        font-size: 24px;
        line-height: normal;
        overflow: hidden;
        text-overflow: ellipsis;
    `
});

export const H3 = styled.h3(() => {
    return `
        font-family: Poppins;
        font-weight: 500;
        font-size: 20px;
        line-height: normal;
        overflow: hidden;
        text-overflow: ellipsis;
    `
});

export const P = styled.p(() => {
    return `
        font-family: Poppins;
        font-weight: 400;
        font-size: 16px;
        line-height: normal;
        overflow: hidden;
        text-overflow: ellipsis;
    `
});

export const Span = styled.span(() => {
    return `
        font-family: Poppins;
        font-weight: 400;
        font-size: 16px;
        line-height: normal;
        overflow: hidden;
        text-overflow: ellipsis;
    `
});

export const A = styled.a(() => {
    return `
    font-family: Poppins;
    font-weight: 800;
    font-size: 12px;
    line-height: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    `
});

export const Li = styled.li(() => {
    return `
    font-family: Poppins;
    font-weight: 400;
    font-size: 16px;
    line-height: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    `
});

export const Label = styled.label(() => {
    return `
    font-family: Inter;
    font-weight: 400;
    font-size: 18px;
    line-height: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #000000;
    `
});

export const Td = styled.td(() => {
    return `
    font-family: Poppins;
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    `
});

export const Th = styled.th(() => {
    return `
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    overflow: Hidden;
    text-overflow: ellipsis;
    `
});
